import React from "react";
import { Toaster } from "sonner";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Services from "../components/site/Services";
import Approach from "../components/site/Approach";
import Accreditations from "../components/site/Accreditations";
import Books from "../components/site/Books";
import Resources from "../components/site/Resources";
import Clients from "../components/site/Clients";
import Testimonials from "../components/site/Testimonials";
import Gallery from "../components/site/Gallery";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="relative bg-[#F9F8F6] text-[#0D0D0D]">
      <Nav />
      <Hero />
      <About />
      <Services />
      <Approach />
      <Accreditations />
      <Testimonials />
      <Gallery />
      <Books />
      <Clients />
      <Resources />
      <Contact />
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D0D0D",
            color: "#F9F8F6",
            border: "1px solid #3E7373",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </main>
  );
};

export default Home;
